import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How GraphQL blows REST out of the water",
  "description": "",
  "published": "2020-01-23T00:00:00.000Z",
  "redirect_from": ["/blog/how-graphql-blows-rest-out-of-the-water/swizec/9300"],
  "categories": "Front End, Technical",
  "hero": "./img/techletter.app-screenshot-1579794681281.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`You're building an app. It needs data from a server. What do you do?`}</p>
    <p>{`Oh, you make a `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` request. Easy.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=fetch('https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F1%2F')%0A%09.then(res%20%3D%3E%20res.json())%0A%09.then(console.log)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "414px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "53.81165919282511%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'215\\'%20viewBox=\\'0%200%20400%20215\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M33%2048c-3%202-3%20118%200%20120%202%203%20332%203%20334%200%203-2%203-118%200-120-3-3-332-3-334%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6ac8c24db0ade52d166912fced034342/ca0a1/techletter.app-screenshot-1579794681281.webp 223w", "/static/6ac8c24db0ade52d166912fced034342/3ca80/techletter.app-screenshot-1579794681281.webp 414w"],
                "sizes": "(max-width: 414px) 100vw, 414px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6ac8c24db0ade52d166912fced034342/e92b6/techletter.app-screenshot-1579794681281.png 223w", "/static/6ac8c24db0ade52d166912fced034342/b910a/techletter.app-screenshot-1579794681281.png 414w"],
                "sizes": "(max-width: 414px) 100vw, 414px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6ac8c24db0ade52d166912fced034342/b910a/techletter.app-screenshot-1579794681281.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And you get eeeevery piece of info about Luke Skywalker.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=json&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%7B%0A%09%22name%22%3A%20%22Luke%20Skywalker%22%2C%0A%09%22height%22%3A%20%22172%22%2C%0A%09%22mass%22%3A%20%2277%22%2C%0A%09%22hair_color%22%3A%20%22blond%22%2C%0A%09%22skin_color%22%3A%20%22fair%22%2C%0A%09%22eye_color%22%3A%20%22blue%22%2C%0A%09%22birth_year%22%3A%20%2219BBY%22%2C%0A%09%22gender%22%3A%20%22male%22%2C%0A%09%22homeworld%22%3A%20%22https%3A%2F%2Fswapi.co%2Fapi%2Fplanets%2F1%2F%22%2C%0A%09%22films%22%3A%20%5B%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F2%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F6%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F3%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F1%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F7%2F%22%0A%09%5D%2C%0A%09%22species%22%3A%20%5B%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fspecies%2F1%2F%22%0A%09%5D%2C%0A%09%22vehicles%22%3A%20%5B%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fvehicles%2F14%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fvehicles%2F30%2F%22%0A%09%5D%2C%0A%09%22starships%22%3A%20%5B%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fstarships%2F12%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fstarships%2F22%2F%22%0A%09%5D%2C%0A%09%22created%22%3A%20%222014-12-09T13%3A50%3A51.644000Z%22%2C%0A%09%22edited%22%3A%20%222014-12-20T21%3A17%3A56.891000Z%22%2C%0A%09%22url%22%3A%20%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F1%2F%22%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "510px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "146.18834080717488%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'584\\'%20viewBox=\\'0%200%20400%20584\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2039c-2%202-1%20505%201%20507%201%201%2029%202%20173%202s172-1%20173-2c2-2%203-505%201-507S28%2037%2026%2039\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cf1ac38bc985ccaab3c31b9b2c25a5d9/ca0a1/techletter.app-screenshot-1579795602007.webp 223w", "/static/cf1ac38bc985ccaab3c31b9b2c25a5d9/75680/techletter.app-screenshot-1579795602007.webp 445w", "/static/cf1ac38bc985ccaab3c31b9b2c25a5d9/b7235/techletter.app-screenshot-1579795602007.webp 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cf1ac38bc985ccaab3c31b9b2c25a5d9/e92b6/techletter.app-screenshot-1579795602007.png 223w", "/static/cf1ac38bc985ccaab3c31b9b2c25a5d9/e66bf/techletter.app-screenshot-1579795602007.png 445w", "/static/cf1ac38bc985ccaab3c31b9b2c25a5d9/0abdd/techletter.app-screenshot-1579795602007.png 510w"],
                "sizes": "(max-width: 510px) 100vw, 510px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cf1ac38bc985ccaab3c31b9b2c25a5d9/0abdd/techletter.app-screenshot-1579795602007.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Well that's annoying ... all you wanted was his name and hair color. Why's the API sending you all this crap? 🤦‍♂️`}</p>
    <p>{`And what's this about Luke's species being `}<inlineCode parentName="p">{`1`}</inlineCode>{`? What the heck is `}<inlineCode parentName="p">{`1`}</inlineCode>{`?`}</p>
    <p>{`Okay, another fetch request.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=fetch('https%3A%2F%2Fswapi.co%2Fapi%2Fspecies%2F1%2F')%0A%09.then(res%20%3D%3E%20res.json())%0A%09.then(console.log)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "422px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "52.91479820627802%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'211\\'%20viewBox=\\'0%200%20400%20211\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M32%2047c-3%203-3%20115%200%20118%202%202%203%202%20168%202s166%200%20168-2c3-3%203-115%200-118S35%2044%2032%2047\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cc9639739f440ef5a94f09a1d2f758d4/ca0a1/techletter.app-screenshot-1579794681428.webp 223w", "/static/cc9639739f440ef5a94f09a1d2f758d4/fc0b3/techletter.app-screenshot-1579794681428.webp 422w"],
                "sizes": "(max-width: 422px) 100vw, 422px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cc9639739f440ef5a94f09a1d2f758d4/e92b6/techletter.app-screenshot-1579794681428.png 223w", "/static/cc9639739f440ef5a94f09a1d2f758d4/fa5c1/techletter.app-screenshot-1579794681428.png 422w"],
                "sizes": "(max-width: 422px) 100vw, 422px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cc9639739f440ef5a94f09a1d2f758d4/fa5c1/techletter.app-screenshot-1579794681428.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You get a bunch of data about humans. Great.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=json&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%7B%0A%09%22name%22%3A%20%22Human%22%2C%0A%09%22classification%22%3A%20%22mammal%22%2C%0A%09%22designation%22%3A%20%22sentient%22%2C%0A%09%22average_height%22%3A%20%22180%22%2C%0A%09%22skin_colors%22%3A%20%22caucasian%2C%20black%2C%20asian%2C%20hispanic%22%2C%0A%09%22hair_colors%22%3A%20%22blonde%2C%20brown%2C%20black%2C%20red%22%2C%0A%09%22eye_colors%22%3A%20%22brown%2C%20blue%2C%20green%2C%20hazel%2C%20grey%2C%20amber%22%2C%0A%09%22average_lifespan%22%3A%20%22120%22%2C%0A%09%22homeworld%22%3A%20%22https%3A%2F%2Fswapi.co%2Fapi%2Fplanets%2F9%2F%22%2C%0A%09%22language%22%3A%20%22Galactic%20Basic%22%2C%0A%09%22people%22%3A%20%5B%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F1%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F4%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F5%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F6%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F7%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F9%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F10%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F11%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F12%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F14%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F18%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F19%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F21%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F22%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F25%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F26%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F28%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F29%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F32%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F34%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F43%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F51%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F60%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F61%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F62%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F66%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F67%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F68%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F69%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F74%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F81%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F84%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F85%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F86%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Fpeople%2F35%2F%22%0A%09%5D%2C%0A%09%22films%22%3A%20%5B%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F2%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F7%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F5%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F4%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F6%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F3%2F%22%2C%0A%09%09%22https%3A%2F%2Fswapi.co%2Fapi%2Ffilms%2F1%2F%22%0A%09%5D%2C%0A%09%22created%22%3A%20%222014-12-10T13%3A52%3A11.567000Z%22%2C%0A%09%22edited%22%3A%20%222015-04-17T06%3A59%3A55.850671Z%22%2C%0A%09%22url%22%3A%20%22https%3A%2F%2Fswapi.co%2Fapi%2Fspecies%2F1%2F%22%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "574px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "220.62780269058297%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'883\\'%20viewBox=\\'0%200%20400%20883\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2036a69055%2069055%200%20001%20813c1%201%2029%202%20176%202s175-1%20176-2c3-2%203-812%201-814S23%2033%2023%2036\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/11aa08e95d17720f9c608a89950fcdc4/ca0a1/techletter.app-screenshot-1579794681620.webp 223w", "/static/11aa08e95d17720f9c608a89950fcdc4/75680/techletter.app-screenshot-1579794681620.webp 445w", "/static/11aa08e95d17720f9c608a89950fcdc4/4e18f/techletter.app-screenshot-1579794681620.webp 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/11aa08e95d17720f9c608a89950fcdc4/e92b6/techletter.app-screenshot-1579794681620.png 223w", "/static/11aa08e95d17720f9c608a89950fcdc4/e66bf/techletter.app-screenshot-1579794681620.png 445w", "/static/11aa08e95d17720f9c608a89950fcdc4/86389/techletter.app-screenshot-1579794681620.png 574w"],
                "sizes": "(max-width: 574px) 100vw, 574px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/11aa08e95d17720f9c608a89950fcdc4/86389/techletter.app-screenshot-1579794681620.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`That's a lot of data just to get the word `}<inlineCode parentName="p">{`"Human"`}</inlineCode>{` out of the `}<a parentName="p" {...{
        "href": "https://swapi.co/"
      }}>{`Star Wars API`}</a>{`, my friend.`}</p>
    <p><img parentName="p" {...{
        "src": "/47e1fcca22164e408fc980c4d5691069/media-qmfpjpAT2fJRK-giphy.gif",
        "alt": "eyeroll giphy"
      }}></img></p>
    <p>{`What about all of Luke's starships? There's just 2 and yet that's 2 more API requests ...`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=fetch(%22https%3A%2F%2Fswapi.co%2Fapi%2Fstarships%2F12%2F%22)%0A%09.then(res%20%3D%3E%20res.json())%0A%09.then(console.log)%0A%09%0Afetch(%22https%3A%2F%2Fswapi.co%2Fapi%2Fstarships%2F22%2F%22)%0A%09.then(res%20%3D%3E%20res.json())%0A%09.then(console.log)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "446px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.3677130044843%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'265\\'%20viewBox=\\'0%200%20400%20265\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M31%2044c-3%202-3%20176%200%20178h338c3-2%203-176%200-178H31\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/151b5fe1cea8680bdf393bcb53f1201b/ca0a1/techletter.app-screenshot-1579794681424.webp 223w", "/static/151b5fe1cea8680bdf393bcb53f1201b/75680/techletter.app-screenshot-1579794681424.webp 445w", "/static/151b5fe1cea8680bdf393bcb53f1201b/5021b/techletter.app-screenshot-1579794681424.webp 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/151b5fe1cea8680bdf393bcb53f1201b/e92b6/techletter.app-screenshot-1579794681424.png 223w", "/static/151b5fe1cea8680bdf393bcb53f1201b/e66bf/techletter.app-screenshot-1579794681424.png 445w", "/static/151b5fe1cea8680bdf393bcb53f1201b/6244b/techletter.app-screenshot-1579794681424.png 446w"],
                "sizes": "(max-width: 446px) 100vw, 446px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/151b5fe1cea8680bdf393bcb53f1201b/6244b/techletter.app-screenshot-1579794681424.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`I don't even wanna know how much data those dump out ...`}</p>
    <p>{`You've just made `}<em parentName="p"><strong parentName="em">{`4`}</strong>{` API requests and transferred a shitload of data`}</em>{` to find out that Luke Skywalker is human, has blond hair, and flies an X-Wing and an Imperial Shuttle.`}</p>
    <p>{`And guess what, you didn't cache anything. How often do you think this data changes? Once a year? Twice?`}</p>
    <p>{`🤦‍♂️`}</p>
    <h2 {...{
      "id": "graphql-to-the-rescue"
    }}>{`GraphQL to the rescue`}</h2>
    <p>{`Here's what that same process looks like with GraphQL.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=graphql&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=query%20luke%20%7B%0A%20%20Person(name%3A%20%22Luke%20Skywalker%22)%20%7B%0A%20%20%20%20name%0A%20%20%20%20hairColor%0A%20%20%20%20species%20%7B%0A%20%20%20%20%20%20name%0A%20%20%20%20%7D%0A%20%20%20%20starships%20%7B%0A%20%20%20%20%20%20name%0A%20%20%20%20%7D%0A%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "374px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "103.13901345291481%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'412\\'%20viewBox=\\'0%200%20400%20412\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M37%2054c-3%202-3%20304%200%20306%202%203%20325%203%20327%200%203-2%203-304%200-306-2-3-325-3-327%200m37%2017c-3%203-2%207%202%209%206%203%2012-5%207-10-3-3-6-3-9%201m22-1c-2%202-3%206%200%208%204%204%2010%201%2010-4s-6-8-10-4\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/987579a9d17519a082c8184f006110c8/ca0a1/techletter.app-screenshot-1579794681447.webp 223w", "/static/987579a9d17519a082c8184f006110c8/ad40e/techletter.app-screenshot-1579794681447.webp 374w"],
                "sizes": "(max-width: 374px) 100vw, 374px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/987579a9d17519a082c8184f006110c8/e92b6/techletter.app-screenshot-1579794681447.png 223w", "/static/987579a9d17519a082c8184f006110c8/52dba/techletter.app-screenshot-1579794681447.png 374w"],
                "sizes": "(max-width: 374px) 100vw, 374px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/987579a9d17519a082c8184f006110c8/52dba/techletter.app-screenshot-1579794681447.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`And the API returns exactly what you wanted with a single request.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=json&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%7B%0A%20%20%22data%22%3A%20%7B%0A%20%20%20%20%22Person%22%3A%20%7B%0A%20%20%20%20%20%20%22name%22%3A%20%22Luke%20Skywalker%22%2C%0A%20%20%20%20%20%20%22hairColor%22%3A%20%5B%0A%20%20%20%20%20%20%20%20%22BLONDE%22%0A%20%20%20%20%20%20%5D%2C%0A%20%20%20%20%20%20%22species%22%3A%20%5B%0A%20%20%20%20%20%20%20%20%7B%0A%20%20%20%20%20%20%20%20%20%20%22name%22%3A%20%22Human%22%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%5D%2C%0A%20%20%20%20%20%20%22starships%22%3A%20%5B%0A%20%20%20%20%20%20%20%20%7B%0A%20%20%20%20%20%20%20%20%20%20%22name%22%3A%20%22X-wing%22%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%20%20%20%20%7B%0A%20%20%20%20%20%20%20%20%20%20%22name%22%3A%20%22Imperial%20shuttle%22%0A%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%5D%0A%20%20%20%20%7D%0A%20%20%7D%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "390px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "149.3273542600897%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'598\\'%20viewBox=\\'0%200%20400%20598\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M35%2052c-2%202-2%2027-2%20249v246l2%202c3%203%20328%203%20331%200l2-2V301c0-222%200-247-2-249l-1-2H36l-1%202m36%2016c-2%203-2%204%200%207%203%204%2010%202%2010-4s-6-8-10-3m22-1c-4%203-4%205-1%208s10%201%2010-4c0-1-4-6-6-6l-3%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9209dd0d1100e0409ac194bef25f314e/ca0a1/techletter.app-screenshot-1579794681567.webp 223w", "/static/9209dd0d1100e0409ac194bef25f314e/a9b47/techletter.app-screenshot-1579794681567.webp 390w"],
                "sizes": "(max-width: 390px) 100vw, 390px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/9209dd0d1100e0409ac194bef25f314e/e92b6/techletter.app-screenshot-1579794681567.png 223w", "/static/9209dd0d1100e0409ac194bef25f314e/727ba/techletter.app-screenshot-1579794681567.png 390w"],
                "sizes": "(max-width: 390px) 100vw, 390px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/9209dd0d1100e0409ac194bef25f314e/727ba/techletter.app-screenshot-1579794681567.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Wait what 😲`}</p>
    <p>{`An API mechanism that gives you total flexibility on the frontend, slashes API requests to almost nothing, `}<em parentName="p">{`and doesn't transfer a bunch of data you don't need?`}</em></p>
    <p>{`That's amazing!`}</p>
    <p>{`You write a query, specify what you want, send to an endpoint, and GraphQL figures out the rest. Want different params? Just say so. Want multiple models? Got it. Wanna go deep? You can.`}</p>
    <p>{`All without making any changes on the server. Within reason.`}</p>
    <p>{`Many GraphQL libraries also add caching so you don't make the same calls too often. Some even consolidate queries so making 10 requests real fast gets wrapped into a single API call. 😲`}</p>
    <p>{`I fell in love the moment it clicked.`}</p>
    <p><img parentName="p" {...{
        "src": "/0a803b79fe27b0dc90bb13572531cbda/media-7FyMQm2vBiTjG-giphy.gif",
        "alt": null
      }}></img></p>
    <p>{`You can `}<a parentName="p" {...{
        "href": "https://swapi.graph.cool/"
      }}>{`try it out on graph.cool's public playground`}</a></p>
    <h2 {...{
      "id": "graphql-even-better-with-hooks"
    }}>{`GraphQL even better with hooks`}</h2>
    <p>{`You don't need much to make a basic GraphQL client. Something like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=fetch('https%3A%2F%2Fswapi.graph.cool%2F'%2C%20%7B%0A%09method%3A%20'POST'%2C%0A%09body%3A%20%7B%0A%09%09operationName%3A%20'luke'%2C%0A%09%09variables%3A%20%7B%7D%2C%0A%09%09query%3A%20%60%0A%09%09%09query%20luke%20%7B%0A%09%09%09%20%20Person(name%3A%20%22Luke%20Skywalker%22)%20%7B%0A%09%09%09%20%20%20%20name%0A%09%09%09%20%20%20%20hairColor%0A%09%09%09%20%20%20%20species%20%7B%0A%09%09%09%20%20%20%20%20%20name%0A%09%09%09%20%20%20%20%7D%0A%09%09%09%20%20%20%20starships%20%7B%0A%09%09%09%20%20%20%20%20%20name%0A%09%09%09%20%20%20%20%7D%0A%09%09%09%20%20%7D%0A%09%09%09%7D%0A%09%09%60%0A%09%7D%0A%7D)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "470px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "116.59192825112108%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'466\\'%20viewBox=\\'0%200%20400%20466\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2043c-3%202-3%20379%200%20381%202%203%20340%203%20342%200%203-2%203-379%200-381-2-3-340-3-342%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/26b6a93fe3ae8d043860b22b39157aa7/ca0a1/techletter.app-screenshot-1579795766609.webp 223w", "/static/26b6a93fe3ae8d043860b22b39157aa7/75680/techletter.app-screenshot-1579795766609.webp 445w", "/static/26b6a93fe3ae8d043860b22b39157aa7/4424c/techletter.app-screenshot-1579795766609.webp 470w"],
                "sizes": "(max-width: 470px) 100vw, 470px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/26b6a93fe3ae8d043860b22b39157aa7/e92b6/techletter.app-screenshot-1579795766609.png 223w", "/static/26b6a93fe3ae8d043860b22b39157aa7/e66bf/techletter.app-screenshot-1579795766609.png 445w", "/static/26b6a93fe3ae8d043860b22b39157aa7/f96db/techletter.app-screenshot-1579795766609.png 470w"],
                "sizes": "(max-width: 470px) 100vw, 470px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/26b6a93fe3ae8d043860b22b39157aa7/f96db/techletter.app-screenshot-1579795766609.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Better than before but eh ...`}</p>
    <p>{`Where GraphQL really shines, my friend, is with React hooks. I like to use `}<inlineCode parentName="p">{`@apollo/react-hooks`}</inlineCode>{`.`}</p>
    <p>{`You get a pattern like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20%7B%20useQuery%20%7D%20from%20'%40apollo%2Freact-hooks'%3B%0Aimport%20gql%20from%20'graphql-tag'%3B%0A%0A%2F%2F%20define%20the%20graphql%20query%0Aconst%20LUKE_QUERY%20%3D%20gql%60%0A%09query%20luke%20%7B%0A%09%20%20Person(name%3A%20%22Luke%20Skywalker%22)%20%7B%0A%09%20%20%20%20name%0A%09%20%20%20%20hairColor%0A%09%20%20%20%20species%20%7B%0A%09%20%20%20%20%20%20name%0A%09%20%20%20%20%7D%0A%09%20%20%20%20starships%20%7B%0A%09%20%20%20%20%20%20name%0A%09%20%20%20%20%7D%0A%09%20%20%7D%0A%09%7D%0A%60%0A%0A%2F%2F%20a%20component%20that%20fetches%20data%20and%20displays%20it%0Aconst%20Luke%20%3D%20()%20%3D%3E%20%7B%0A%09const%20%7B%20loading%2C%20data%20%7D%20%3D%20useQuery(LUKE_QUERY)%0A%09%0A%09return%20loading%20%3F%20%0A%09%09%3Cp%3EFetching%20...%3C%2Fp%3E%20%0A%09%3A%20%0A%09%09%3Cp%3E%7Bdata.Person.name%7D%20is%20a%20%7Bdata.Person.hairColor%5B0%5D%7D%20%7Bdata.Person.species%5B0%5D.name%7D%20and%20flies%20around%20in%20%7Bdata.Person.starships.map(ship%20%3D%3E%20ship.name).join(%22%2C%20%22)%7D%3C%2Fp%3E%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "67.2645739910314%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'270\\'%20viewBox=\\'0%200%20400%20270\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2024c-2%2011-1%20226%200%20227%202%202%20372%202%20374%200%201-1%202-216%200-227v-5H13v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2a216a5f1953bd5de1a9c06c98f828ad/ca0a1/techletter.app-screenshot-1579794681647.webp 223w", "/static/2a216a5f1953bd5de1a9c06c98f828ad/75680/techletter.app-screenshot-1579794681647.webp 445w", "/static/2a216a5f1953bd5de1a9c06c98f828ad/8d1ba/techletter.app-screenshot-1579794681647.webp 890w", "/static/2a216a5f1953bd5de1a9c06c98f828ad/a9a89/techletter.app-screenshot-1579794681647.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/2a216a5f1953bd5de1a9c06c98f828ad/e92b6/techletter.app-screenshot-1579794681647.png 223w", "/static/2a216a5f1953bd5de1a9c06c98f828ad/e66bf/techletter.app-screenshot-1579794681647.png 445w", "/static/2a216a5f1953bd5de1a9c06c98f828ad/4ef49/techletter.app-screenshot-1579794681647.png 890w", "/static/2a216a5f1953bd5de1a9c06c98f828ad/2bef9/techletter.app-screenshot-1579794681647.png 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/2a216a5f1953bd5de1a9c06c98f828ad/4ef49/techletter.app-screenshot-1579794681647.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Render `}<inlineCode parentName="p">{`<Luke />`}</inlineCode>{` and it first says `}<inlineCode parentName="p">{`Fetching ...`}</inlineCode>{` then changes into `}<inlineCode parentName="p">{`Luke Skywalker is a BLONDE Human and flies around in X-wing, Imperial shuttle`}</inlineCode>{`.`}</p>
    <p>{`Not the perfectest English but that's way better than cobbling together 4 API requests, my friend.`}</p>
    <p>{`You could even make your component accept a search parameter.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20%7B%20useQuery%20%7D%20from%20'%40apollo%2Freact-hooks'%3B%0Aimport%20gql%20from%20'graphql-tag'%3B%0A%0A%2F%2F%20define%20the%20graphql%20query%0Aconst%20PERSON_QUERY%20%3D%20gql%60%0A%09query%20person(%24name%3A%20String!)%20%7B%0A%09%20%20Person(name%3A%20%24name)%20%7B%0A%09%20%20%20%20name%0A%09%20%20%20%20hairColor%0A%09%20%20%20%20species%20%7B%0A%09%20%20%20%20%20%20name%0A%09%20%20%20%20%7D%0A%09%20%20%20%20starships%20%7B%0A%09%20%20%20%20%20%20name%0A%09%20%20%20%20%7D%0A%09%20%20%7D%0A%09%7D%0A%60%0A%0A%2F%2F%20a%20component%20that%20fetches%20data%20and%20displays%20it%0Aconst%20Person%20%3D%20(%7B%20name%20%7D)%20%3D%3E%20%7B%0A%09const%20%7B%20loading%2C%20data%20%7D%20%3D%20useQuery(PERSON_QUERY%2C%20%7B%0A%09%09variables%3A%20%7B%0A%09%09%09name%0A%09%09%7D%0A%09%7D)%0A%09%0A%09return%20loading%20%3F%20%0A%09%09%3Cp%3EFetching%20...%3C%2Fp%3E%20%0A%09%3A%20%0A%09%09%3Cp%3E%7Bdata.Person.name%7D%20is%20a%20%7Bdata.Person.hairColor%5B0%5D%7D%20%7Bdata.Person.species%5B0%5D.name%7D%20and%20flies%20around%20in%20%7Bdata.Person.starships.map(ship%20%3D%3E%20ship.name).join(%22%2C%20%22)%7D%3C%2Fp%3E%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.43946188340806%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'298\\'%20viewBox=\\'0%200%20400%20298\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2024c-2%2011-1%20254%200%20255%202%202%20372%202%20374%200%201-1%202-244%200-255v-5H13v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/979481d82e9ae068a6a55619a4b4949e/ca0a1/techletter.app-screenshot-1579794681459.webp 223w", "/static/979481d82e9ae068a6a55619a4b4949e/75680/techletter.app-screenshot-1579794681459.webp 445w", "/static/979481d82e9ae068a6a55619a4b4949e/8d1ba/techletter.app-screenshot-1579794681459.webp 890w", "/static/979481d82e9ae068a6a55619a4b4949e/a9a89/techletter.app-screenshot-1579794681459.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/979481d82e9ae068a6a55619a4b4949e/e92b6/techletter.app-screenshot-1579794681459.png 223w", "/static/979481d82e9ae068a6a55619a4b4949e/e66bf/techletter.app-screenshot-1579794681459.png 445w", "/static/979481d82e9ae068a6a55619a4b4949e/4ef49/techletter.app-screenshot-1579794681459.png 890w", "/static/979481d82e9ae068a6a55619a4b4949e/2bef9/techletter.app-screenshot-1579794681459.png 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/979481d82e9ae068a6a55619a4b4949e/4ef49/techletter.app-screenshot-1579794681459.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Now you can use `}<inlineCode parentName="p">{`<Person name="luke skywalker" />`}</inlineCode>{` to show data about Luke, and `}<inlineCode parentName="p">{`<Person name="chewbacca" />`}</inlineCode>{` to learn about Chewie.`}</p>
    <p>{`All without changing a bunch of Redux state, coordinating a bazillion API requests, dealing with smart components, dumb components, presentational components, data stores, caching, configuration, permissions, anything. It just works.`}</p>
    <p>{`🤯`}</p>
    <h2 {...{
      "id": "the-edge-first-architecture"
    }}>{`The edge first architecture`}</h2>
    <p>{`What GraphQL enables and hooks facilitate is the Edge First Architecture on the frontend. You can think of it sort of as `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Edge_computing"
      }}>{`edge computing`}</a>{` applied to your components.`}</p>
    <p>{`The past few years of React common sense taught us to put everything in a global store. Almost everything. Anything that multiple components might need.`}</p>
    <p>{`You get a unidirectional data flow, easy to understand state transitions, and a total mess of an impenetrable state tree as your app grows. Things slow down, debugging gets hard, and help you god if you can't keep the entire app in your head. I'm looking at you sagas 😒`}</p>
    <p><img parentName="p" {...{
        "src": "/85a36be624120652ecc87f71ac6bd9cf/media-3ohzdUbXhdSXOvwJbO-giphy-downsized-medium.gif",
        "alt": "ded giphy"
      }}></img></p>
    <p>{`With edge first, we turn that upside-down. `}<em parentName="p">{`The edge does the work`}</em></p>
    <p>{`Look at the `}<inlineCode parentName="p">{`<Person />`}</inlineCode>{` component.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20a%20component%20that%20fetches%20data%20and%20displays%20it%0Aconst%20Person%20%3D%20(%7B%20name%20%7D)%20%3D%3E%20%7B%0A%09const%20%7B%20loading%2C%20data%20%7D%20%3D%20useQuery(PERSON_QUERY%2C%20%7B%0A%09%09variables%3A%20%7B%0A%09%09%09name%0A%09%09%7D%0A%09%7D)%0A%09%0A%09return%20loading%20%3F%20%0A%09%09%3Cp%3EFetching%20...%3C%2Fp%3E%20%0A%09%3A%20%0A%09%09%3Cp%3E%7Bdata.Person.name%7D%20is%20a%20%7Bdata.Person.hairColor%5B0%5D%7D%20%7Bdata.Person.species%5B0%5D.name%7D%20and%20flies%20around%20in%20%7Bdata.Person.starships.map(ship%20%3D%3E%20ship.name).join(%22%2C%20%22)%7D%3C%2Fp%3E%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "41.25560538116592%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'164\\'%20viewBox=\\'0%200%20400%20164\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%2024v120c1%203%20373%203%20374%200V19H13v5\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/238bc1f24ab4459b07341bf297511763/ca0a1/techletter.app-screenshot-1579794681475.webp 223w", "/static/238bc1f24ab4459b07341bf297511763/75680/techletter.app-screenshot-1579794681475.webp 445w", "/static/238bc1f24ab4459b07341bf297511763/8d1ba/techletter.app-screenshot-1579794681475.webp 890w", "/static/238bc1f24ab4459b07341bf297511763/a9a89/techletter.app-screenshot-1579794681475.webp 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/238bc1f24ab4459b07341bf297511763/e92b6/techletter.app-screenshot-1579794681475.png 223w", "/static/238bc1f24ab4459b07341bf297511763/e66bf/techletter.app-screenshot-1579794681475.png 445w", "/static/238bc1f24ab4459b07341bf297511763/4ef49/techletter.app-screenshot-1579794681475.png 890w", "/static/238bc1f24ab4459b07341bf297511763/2bef9/techletter.app-screenshot-1579794681475.png 1024w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/238bc1f24ab4459b07341bf297511763/4ef49/techletter.app-screenshot-1579794681475.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`It's doing all the work. Fetches its own data, deals with loading states, maybe errors, displays the result when ready.`}</p>
    <p>{`You can put this `}<em parentName="p">{`anywhere`}</em>{` in your app and it Just Works™. No props to pass in, no hooking into global state, no coordination.`}</p>
    <p>{`Self-contained. Beautiful.`}</p>
    <h3 {...{
      "id": "but-what-about-performance-swizec"
    }}>{`But what about performance, Swizec?`}</h3>
    <p>{`You're getting all the benefits you used to. They're just hidden deep inside the hooks machinery of your GraphQL library.`}</p>
    <p>{`That `}<inlineCode parentName="p">{`useQuery`}</inlineCode>{` hook looks like it just runs a fetch request, sure. And it does.`}</p>
    <p>{`But `}<inlineCode parentName="p">{`useQuery`}</inlineCode>{` also talks to a global context, coordinates similar API requests, adds a caching layer, and ensures that even if you render `}<inlineCode parentName="p">{`<Person name="luke skywalker" />`}</inlineCode>{` twice in a row, performance doesn't suffer.`}</p>
    <p>{`Which is more than you've ever ensured with a global store and a lot of hard work isn't it, my friend? Sure is more than I have 😇`}</p>
    <hr></hr>
    <p>{`Honestly GraphQL revolutionized how I think about the frontend and the Edge First Architecture is the free-est I've ever felt building great webapps fast.`}</p>
    <p>{`What do you think? hit reply`}</p>
    <p>{`Cheers, ~Swizec`}</p>
    <p>{`PS: GraphQL supports `}<em parentName="p">{`writing`}</em>{` as well, using a `}<inlineCode parentName="p">{`mutation`}</inlineCode>{`. You can even subscribe to changes live.`}</p>
    <p>{`PPS: GraphQL makes backends easier too. Rather than implementing a billion endpoints, you create 1 endpoint and write small resolver functions for individual queries.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      